module.exports = __webpack_public_path__ + "img/serveObj.6eae8cb5.png";